/*
  Плашка «Узнать сроки поставки».

  Две задачи:
  1. Показывать блок только когда выбранного варианта нет в наличии,
     пересчитывая при переключении размера без перезагрузки страницы.
  2. Отправлять заявку на shop-api и показывать ответ.
*/

(function () {
  'use strict';

  var MESSAGES = {
    en: {
      required: 'Please fill in the required fields.',
      email: 'Please check the email address.',
      consent: 'Please confirm your consent.',
      network: 'Connection problem. Please try again.',
      sending: 'Sending…',
      successTitle: 'Request sent',
      phone: 'Please check the phone number, with the country code.',
      channel: 'Please choose how we should reach you.',
      username: 'Please check the Telegram username, for example @name.',
      useUsername: 'Use a username instead',
      usePhone: 'Use a phone number instead',
      typo: 'Did you mean {fix}? Edit the address or press Send again to keep it as it is.',
      emailTitle: 'Confirmation email sent',
      emailCheck: 'Please check your inbox or spam folder.',
      emailAddBefore: 'To make sure you receive our reply, add',
      emailAddAfter: 'to your contacts.',
      sumItem: 'Item',
      sumNeeded: 'Preferred delivery date',
      lblEmail: 'Email',
      lblWhatsapp: 'WhatsApp number',
      lblTgPhone: 'Telegram number',
      lblTgUser: 'Telegram username',
      nextTitle: 'We\'ll reply within 1 to 3 business days',
      nextText: 'We\'re checking availability and delivery time with the manufacturer and will contact you.',
      ourAddress: 'our address',
    },
    ru: {
      required: 'Заполните обязательные поля.',
      email: 'Проверьте адрес электронной почты.',
      consent: 'Подтвердите согласие.',
      network: 'Проблема со связью. Попробуйте ещё раз.',
      sending: 'Отправляем…',
      successTitle: 'Запрос отправлен',
      phone: 'Проверьте номер телефона, вместе с кодом страны.',
      channel: 'Выберите, как с вами связаться.',
      username: 'Проверьте ник в Telegram, например @name.',
      useUsername: 'Указать ник вместо номера',
      usePhone: 'Указать номер телефона вместо ника',
      typo: 'Возможно, вы имели в виду {fix}? Исправьте адрес или нажмите «Отправить» ещё раз, чтобы оставить как есть.',
      emailTitle: 'Письмо с подтверждением отправлено',
      emailCheck: 'Проверьте входящие или папку «Спам».',
      emailAddBefore: 'Чтобы наш ответ точно дошёл до вас, добавьте',
      emailAddAfter: 'в контакты.',
      sumItem: 'Изделие',
      sumNeeded: 'Желаемый срок',
      lblEmail: 'Email',
      lblWhatsapp: 'Номер WhatsApp',
      lblTgPhone: 'Номер Telegram',
      lblTgUser: 'Ник в Telegram',
      nextTitle: 'Ответим в течение 1-3 рабочих дней',
      nextText: 'Мы уточняем наличие и срок поставки у производителя и свяжемся с вами.',
      ourAddress: 'наш адрес',
    },
    es: {
      required: 'Complete los campos obligatorios.',
      email: 'Revise la dirección de correo.',
      consent: 'Confirme su consentimiento.',
      network: 'Problema de conexión. Inténtelo de nuevo.',
      sending: 'Enviando…',
      successTitle: 'Solicitud enviada',
      phone: 'Revise el número de teléfono, con el prefijo del país.',
      channel: 'Elija cómo prefiere que le contactemos.',
      username: 'Revise el usuario de Telegram, por ejemplo @name.',
      useUsername: 'Indicar el usuario en lugar del número',
      usePhone: 'Indicar el número de teléfono en lugar del usuario',
      typo: '¿Quiso decir {fix}? Corrija la dirección o pulse Enviar de nuevo para dejarla tal cual.',
      emailTitle: 'Correo de confirmación enviado',
      emailCheck: 'Revise su bandeja de entrada o la carpeta de spam.',
      emailAddBefore: 'Para recibir nuestra respuesta, añada',
      emailAddAfter: 'a sus contactos.',
      sumItem: 'Artículo',
      sumNeeded: 'Fecha de entrega preferida',
      lblEmail: 'Email',
      lblWhatsapp: 'Número de WhatsApp',
      lblTgPhone: 'Número de Telegram',
      lblTgUser: 'Usuario de Telegram',
      nextTitle: 'Responderemos en 1 a 3 días laborables',
      nextText: 'Estamos confirmando la disponibilidad y el plazo de entrega con el fabricante y nos pondremos en contacto con usted.',
      ourAddress: 'nuestra dirección',
    },
  };

  function t(locale, key) {
    return (MESSAGES[locale] || MESSAGES.en)[key];
  }

  // Частые опечатки в доменах почты. Подсказываем, но не запрещаем:
  // у человека может быть и такой адрес.
  var DOMAIN_FIXES = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmail.con': 'gmail.com',
    'gmail.co': 'gmail.com', 'gmal.com': 'gmail.com', 'gnail.com': 'gmail.com',
    'gamil.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gmail.cm': 'gmail.com',
    'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'outlok.com': 'outlook.com', 'outlook.con': 'outlook.com',
    'icloud.con': 'icloud.com', 'iclod.com': 'icloud.com'
  };

  function suggestEmail(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) return '';
    var fix = DOMAIN_FIXES[email.slice(at + 1).toLowerCase()];
    return fix ? email.slice(0, at + 1) + fix : '';
  }

  // intl-tel-input: поле номера с флагом и кодом страны. Грузим с CDN только
  // когда клиент выбрал WhatsApp. Если не загрузилось, поле остаётся обычным
  // телефонным, номер проверяем сами.
  var ITI_VERSION = '25.12.5';
  var ITI_BASE = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + ITI_VERSION + '/build/';
  var itiPromise = null;

  function loadIti() {
    if (itiPromise) return itiPromise;
    itiPromise = new Promise(function (resolve, reject) {
      if (window.intlTelInput) return resolve(window.intlTelInput);
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = ITI_BASE + 'css/intlTelInput.min.css';
      document.head.appendChild(css);
      var sc = document.createElement('script');
      sc.src = ITI_BASE + 'js/intlTelInputWithUtils.min.js';
      sc.onload = function () { window.intlTelInput ? resolve(window.intlTelInput) : reject(); };
      sc.onerror = reject;
      document.head.appendChild(sc);
    });
    return itiPromise;
  }

  // Артикул в конце названия («85A007-5022») не должен рваться по дефису:
  // подменяем дефисы в последнем слове на неразрывные, тогда артикул переносится целиком.
  function keepSku(str) {
    return String(str || '').replace(/(\S+)\s*$/, function (m) {
      return m.replace(/-/g, '\u2011');
    });
  }

  function QuoteRequest(root) {
    this.root = root;
    // Секция кладёт data-section-id, блок — data-block-id
    this.sectionId = root.dataset.blockId || root.dataset.sectionId;
    this.locale = root.dataset.locale || 'en';
    this.endpoint = root.dataset.endpoint;

    this.modal = root.querySelector('[data-quote-modal]');
    this.form = root.querySelector('[data-quote-form]');
    this.message = root.querySelector('[data-quote-message]');
    this.submitBtn = root.querySelector('[data-quote-submit]');
    this.submitLabel = this.submitBtn ? this.submitBtn.textContent.trim() : '';

    this.channelSelect = root.querySelector('[data-quote-channel]');
    this.emailRow = root.querySelector('[data-quote-email-row]');
    this.phoneRow = root.querySelector('[data-quote-phone-row]');
    this.phoneInput = root.querySelector('[data-quote-phone]');
    this.usernameRow = root.querySelector('[data-quote-username-row]');
    this.usernameInput = root.querySelector('[data-quote-username]');
    this.tgSwitch = root.querySelector('[data-quote-tgswitch]');
    this.tgMode = 'phone'; // в Telegram: 'phone' или 'username'
    this.iti = null;
    this.typoOk = '';

    var productTitle = root.querySelector('[data-quote-product-title]');
    if (productTitle) productTitle.textContent = keepSku(productTitle.textContent.trim());

    this.availability = this.readAvailability();
    this.buildDropdown();
    this.bind();
    this.watchVariant();
  }

  // Наличие всех вариантов положено в страницу при рендере — запросов не нужно
  QuoteRequest.prototype.readAvailability = function () {
    var node = document.querySelector('[data-quote-variants="' + this.sectionId + '"]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  };

  QuoteRequest.prototype.bind = function () {
    var self = this;

    this.root.querySelectorAll('[data-quote-open]').forEach(function (el) {
      el.addEventListener('click', function () { self.open(); });
    });

    this.root.querySelectorAll('[data-quote-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.close(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !self.modal || self.modal.hidden) return;
      // Escape в открытом списке стран закрывает только список, не всё окно
      if (document.querySelector('.iti__selected-country[aria-expanded="true"]')) return;
      self.close();
    });

    if (this.channelSelect) {
      this.channelSelect.addEventListener('change', function () { self.applyChannel(); });
    }
    if (this.tgSwitch) {
      this.tgSwitch.addEventListener('click', function () {
        self.tgMode = self.tgMode === 'phone' ? 'username' : 'phone';
        self.applyChannel();
        var f = self.tgMode === 'username' ? self.usernameInput : self.phoneInput;
        if (f) setTimeout(function () { f.focus(); }, 30);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.submit();
      });
    }
  };

  /*
    Смена варианта. Dawn не даёт единого события во всех версиях,
    поэтому слушаем и своё событие темы, и просто изменения формы,
    и подстраховываемся наблюдением за скрытым полем с id варианта.
  */
  /**
   * Поле, в котором лежит выбранный вариант.
   *
   * Почему не через форму: на странице товара первой идёт форма рассрочки
   * (product-form-installment, action="/cart/add"), и внутри неё свой
   * <input type="hidden" name="id"> со статичным значением. Скрипт цеплялся
   * за неё и следил за полем, которое никогда не меняется.
   *
   * Настоящий выбор варианта — это <select name="id"> (dropdown-пикер) или
   * .product-variant-id, привязанные к форме атрибутом form="...".
   */
  function findVariantField() {
    var sel = document.querySelector('variant-selects select[name="id"], select[name="id"]');
    if (sel) return sel;
    var pf = document.querySelector('product-form form');
    if (pf) {
      var inForm = pf.querySelector('[name="id"]:not([disabled])');
      if (inForm) return inForm;
    }
    return document.querySelector('input.product-variant-id, input[name="id"]:not([disabled])');
  }

  QuoteRequest.prototype.watchVariant = function () {
    var self = this;

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) self.update(e.detail.variant.id);
    });

    var input = findVariantField();
    if (input) {
      var productForm = input.form;
      if (input) {
        productForm.addEventListener('change', function () {
          setTimeout(function () { self.update(input.value); }, 60);
        });

        // Dawn меняет значение скрытого поля программно — событие change не всегда летит
        if (window.MutationObserver) {
          new MutationObserver(function () {
            self.update(input.value);
          }).observe(input, { attributes: true, attributeFilter: ['value'] });
        }

        var lastSeen = input.value;
        setInterval(function () {
          if (input.value !== lastSeen) {
            lastSeen = input.value;
            self.update(input.value);
          }
        }, 400);
      }
    }
  };

  QuoteRequest.prototype.update = function (variantId) {
    if (!variantId) return;
    var id = String(variantId);
    var available = this.availability[id];

    this.root.dataset.variantId = id;

    // Неизвестный вариант — не показываем: лучше промолчать, чем соврать
    var shouldShow = available === false;

    this.root.hidden = !shouldShow;
    if (!shouldShow && this.modal && !this.modal.hidden) this.close();

    this.updateVariantTitle(id);
  };

  QuoteRequest.prototype.updateVariantTitle = function (id) {
    // modal ищем отдельно: после open() он живёт в body, а не внутри root
    var target = (this.modal || this.root).querySelector('[data-quote-variant-title]');
    if (!target) return;

    // Именно форма товара, а не первое поле name="id" на странице:
    // в блоках «похожие товары» такие формы тоже есть, и с них уезжали бы
    // чужие опции.
    var option = findVariantField();
    if (option && option.form) {
      // form.elements, а НЕ querySelectorAll: в Dawn поля выбора варианта
      // лежат ВНЕ <form> и привязаны атрибутом form="...". Поиск внутри
      // формы их не видит — из-за этого размер в форме не обновлялся.
      var selected = Array.prototype.filter.call(option.form.elements, function (el) {
        if (el.tagName === 'SELECT') return true;
        if (el.type === 'radio' || el.type === 'checkbox') return el.checked;
        return false;
      });
      var parts = [];
      selected.forEach(function (el) {
        if (!el.name) return;
        // Имя поля опции зависит от темы: Dawn 11 даёт option1/option2,
        // Dawn 15 — «Size-1», «Color-2» (название опции + позиция).
        // Поэтому отбираем не по префиксу, а по принадлежности к выбору
        // варианта: исключаем служебные поля формы.
        var n = el.name;
        if (n === 'id' || n === 'quantity' || n.indexOf('properties[') === 0) return;
        // Актуальный Dawn называет поля опций «options[Size]».
        // Но там же лежит служебное options[prefix] — в подпись оно попадать
        // не должно, иначе клиент увидит «prefix: last».
        if (n === 'options[prefix]' || n === 'options[section_id]') return;
        if (n === 'section-id' || n === 'product-id' || n === 'sections') return;
        if (n.indexOf('form_type') === 0 || n.indexOf('utf8') === 0) return;
        if (el.type === 'hidden') return;
        // Название опции (Size / Memory / Color) — из легенды radio-группы
        // или из <label> у select. Без него выводим одно значение.
        var name = '';
        var fieldset = el.closest && el.closest('fieldset');
        var legend = fieldset && fieldset.querySelector('legend');
        if (legend) {
          name = legend.textContent.split(':')[0].trim();
        } else if (el.id) {
          var lab = document.querySelector('label[for="' + el.id + '"]');
          if (lab) name = lab.textContent.split(':')[0].trim();
        }
        // Dawn 15: у <select> легенды нет, а подпись лежит рядом в
        // .form__label внутри .product-form__input. Запасной путь —
        // из самого имени поля: «Size-1» -> «Size».
        if (!name) {
          var wrap = el.closest && el.closest('.product-form__input');
          var lbl = wrap && wrap.querySelector('.form__label, label');
          if (lbl) name = lbl.textContent.split(':')[0].trim();
        }
        // Крайний случай — само имя поля. Форматы разных версий Dawn:
        // «options[Size]» (актуальный), «Size-1», «Size», «option1».
        if (!name) {
          var br = n.match(/\[([^\]]+)\]/);
          name = br ? br[1] : n.replace(/-\d+$/, '');
          if (/^option\d*$/i.test(name)) name = '';
        }
        parts.push(name ? name + ': ' + el.value : el.value);
      });
      if (parts.length) target.textContent = parts.join(' \u00b7 ');
    }
  };

  // Свой выпадающий список вместо системного. Системный на macOS рисуется
  // поверх поля и сдвинут, стилизовать его нельзя. На телефонах оставляем
  // родной выбор: он там удобнее.
  QuoteRequest.prototype.buildDropdown = function () {
    var sel = this.channelSelect;
    if (!sel || !window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var self = this;
    var wrap = document.createElement('div');
    wrap.className = 'quote-request__dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quote-request__input quote-request__select quote-request__dd-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var list = document.createElement('ul');
    list.className = 'quote-request__dd-list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    Array.prototype.forEach.call(sel.options, function (o) {
      if (o.disabled) return;
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.dataset.value = o.value;
      li.textContent = o.textContent;
      list.appendChild(li);
    });
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(btn);
    wrap.appendChild(list);
    wrap.appendChild(sel);
    sel.classList.add('quote-request__native-hidden');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');
    this.dd = { wrap: wrap, btn: btn, list: list, active: -1 };

    var items = function () { return list.querySelectorAll('li'); };
    var setActive = function (i) {
      var els = items();
      if (!els.length) return;
      self.dd.active = (i + els.length) % els.length;
      Array.prototype.forEach.call(els, function (el, k) {
        el.classList.toggle('is-active', k === self.dd.active);
      });
    };
    var open = function () {
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var cur = Array.prototype.findIndex.call(items(), function (el) { return el.dataset.value === sel.value; });
      setActive(cur < 0 ? 0 : cur);
    };
    var close = function () {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    };
    var choose = function (value) {
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      close();
      btn.focus();
    };
    this.dd.close = close;

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest && e.target.closest('li');
      if (li) choose(li.dataset.value);
    });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest && e.target.closest('li');
      if (li) setActive(Array.prototype.indexOf.call(items(), li));
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !list.hidden) { e.stopPropagation(); close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (list.hidden) open(); else setActive(self.dd.active + (e.key === 'ArrowDown' ? 1 : -1));
      } else if (e.key === 'Enter' || e.key === ' ') {
        if (!list.hidden) { e.preventDefault(); var els = items(); if (els[self.dd.active]) choose(els[self.dd.active].dataset.value); }
      } else if (e.key === 'Tab') {
        close();
      }
    });
    btn.addEventListener('blur', function () { setTimeout(close, 120); });
    this.syncDropdown();
  };

  QuoteRequest.prototype.syncDropdown = function () {
    if (!this.dd) return;
    var sel = this.channelSelect;
    var opt = sel.options[sel.selectedIndex];
    var empty = !sel.value;
    this.dd.btn.textContent = opt ? opt.textContent : '';
    this.dd.btn.classList.toggle('is-placeholder', empty);
    Array.prototype.forEach.call(this.dd.list.querySelectorAll('li'), function (li) {
      li.setAttribute('aria-selected', li.dataset.value === sel.value ? 'true' : 'false');
    });
  };

  QuoteRequest.prototype.markChannelInvalid = function (on) {
    if (!this.channelSelect) return;
    if (on) this.channelSelect.setAttribute('aria-invalid', 'true');
    else this.channelSelect.removeAttribute('aria-invalid');
    if (this.dd) this.dd.btn.setAttribute('aria-invalid', on ? 'true' : 'false');
  };

  QuoteRequest.prototype.channel = function () {
    var v = this.channelSelect ? this.channelSelect.value : '';
    return v === 'whatsapp' || v === 'telegram' || v === 'email' ? v : '';
  };

  // Показываем поле только под выбранный канал
  QuoteRequest.prototype.applyChannel = function () {
    var ch = this.channel();
    var wa = ch === 'whatsapp' || ch === 'telegram'; // канал с номером телефона
    this.markChannelInvalid(false);
    this.syncDropdown();
    // Пока канал не выбран, обе строки скрыты: поле появляется после выбора
    var tg = ch === 'telegram';
    var useName = tg && this.tgMode === 'username';
    if (this.emailRow) this.emailRow.hidden = ch !== 'email';
    if (this.phoneRow) this.phoneRow.hidden = !wa || useName;
    if (this.usernameRow) this.usernameRow.hidden = !useName;
    if (this.tgSwitch) {
      this.tgSwitch.hidden = !tg;
      this.tgSwitch.textContent = t(this.locale, useName ? 'usePhone' : 'useUsername');
    }
    if (this.message) this.message.hidden = true;
    if (wa && !useName) this.initPhone();
  };

  QuoteRequest.prototype.initPhone = function () {
    var self = this;
    if (this.iti || this.itiTried || !this.phoneInput) return;
    this.itiTried = true;
    var country = (this.root.dataset.country || '').toLowerCase();
    var lang = this.locale;
    loadIti().then(function (intlTelInput) {
      var opts = {
        initialCountry: country || 'us',
        separateDialCode: true,
        strictMode: true,
        countrySearch: true,
        dropdownContainer: document.body
      };
      var make = function (i18n) {
        if (i18n) opts.i18n = i18n;
        self.iti = intlTelInput(self.phoneInput, opts);
      };
      // Названия стран на языке витрины. Нет перевода или не загрузился: английский.
      if (lang === 'ru' || lang === 'es') {
        import(ITI_BASE + 'js/i18n/' + lang + '/index.js')
          .then(function (m) { make(m.default); })
          .catch(function () { make(null); });
      } else {
        make(null);
      }
    }).catch(function () {
      self.phoneInput.placeholder = '+';
    });
  };

  // Номер в международном формате или пустая строка, если он не годится
  QuoteRequest.prototype.readPhone = function () {
    if (this.iti) {
      return this.iti.isValidNumber() ? this.iti.getNumber() : '';
    }
    var raw = (this.phoneInput.value || '').trim();
    var digits = raw.replace(/[^0-9]/g, '');
    if (raw.charAt(0) !== '+' || digits.length < 8 || digits.length > 15) return '';
    return '+' + digits;
  };

  // Номер для экрана благодарности: «+380 93 223 0049» вместо «+380932230049»
  QuoteRequest.prototype.displayPhone = function (e164) {
    try {
      if (this.iti && window.intlTelInput && window.intlTelInput.utils) {
        var f = this.iti.getNumber(window.intlTelInput.utils.numberFormat.INTERNATIONAL);
        if (f) return f;
      }
    } catch (e) {}
    return e164;
  };

  QuoteRequest.prototype.open = function () {
    if (!this.modal) return;
    // Dawn вешает на product__info-wrapper анимацию с transform, а любой
    // transform у предка делает его точкой отсчёта для position: fixed —
    // модалка прижималась бы к колонке товара вместо окна браузера.
    // Переносим её в конец body, где предков с transform нет.
    if (this.modal.parentNode !== document.body) {
      document.body.appendChild(this.modal);
    }
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    // Плавающий чат магазина перекрывает кнопки формы: на время формы прячем его (CSS)
    document.documentElement.classList.add('quote-request-open');
    var first = this.form && this.form.querySelector('input[name="firstName"]');
    if (first) setTimeout(function () { first.focus(); }, 50);
  };

  QuoteRequest.prototype.close = function () {
    if (!this.modal) return;
    this.modal.hidden = true;
    document.body.style.overflow = '';
    document.documentElement.classList.remove('quote-request-open');
  };

  QuoteRequest.prototype.showSuccess = function (text, ctx) {
    var scope = this.modal || this.root;
    var success = scope.querySelector('[data-quote-success]');
    if (!success) {
      // Подстраховка: если разметки нет, показываем обычное сообщение
      return this.showMessage(text, 'ok');
    }

    var title = success.querySelector('[data-quote-success-title]');
    var body = success.querySelector('[data-quote-success-text]');
    // Текст из настроек блока приоритетнее словаря: он редактируется
    // в конструкторе, словарь — запасной вариант
    if (title && !title.textContent.trim()) {
      title.textContent = t(this.locale, 'successTitle');
    }
    // Описание тоже из настроек блока. Ответом сервера перезаписываем
    // только когда настройка пуста — иначе текст, набранный в конструкторе,
    // затирался бы на каждой отправке.
    // Экран благодарности: что запросили, куда ответим и что будет дальше.
    // Контакт показываем как ввёл клиент, чтобы опечатку было видно сразу.
    var summary = success.querySelector('[data-quote-summary]');
    var oldNext = success.querySelector('[data-quote-next]');
    if (oldNext) oldNext.parentNode.removeChild(oldNext);
    if (summary && ctx && ctx.contact) {
      summary.textContent = '';
      var isEmail = ctx.channel === 'email';
      var isUser = ctx.contact.charAt(0) === '@';
      var addRow = function (label, value, note) {
        if (!value) return;
        var row = document.createElement('div');
        row.className = 'quote-request__summary-row';
        var dt = document.createElement('dt');
        dt.textContent = label;
        var dd = document.createElement('dd');
        dd.textContent = value;
        row.appendChild(dt);
        row.appendChild(dd);
        if (note) {
          var n = document.createElement('div');
          n.className = 'quote-request__summary-note';
          n.textContent = note;
          dd.appendChild(n);
        }
        summary.appendChild(row);
      };
      var itemLines = String(ctx.item || '').split('\n');
      var itemDd = keepSku(itemLines[0]);
      addRow(t(this.locale, 'sumItem'), itemDd);
      // размер светлее названия
      if (itemLines[1]) {
        var lastDd = summary.lastChild && summary.lastChild.querySelector('dd');
        if (lastDd) {
          var sz = document.createElement('div');
          sz.className = 'quote-request__summary-sub';
          sz.textContent = itemLines[1];
          lastDd.appendChild(sz);
        }
      }
      var needed = String(ctx.needed || '');
      addRow(t(this.locale, 'sumNeeded'), needed.charAt(0).toUpperCase() + needed.slice(1));
      var contactLabel = isEmail ? 'lblEmail'
        : ctx.channel === 'whatsapp' ? 'lblWhatsapp'
        : isUser ? 'lblTgUser' : 'lblTgPhone';
      addRow(t(this.locale, contactLabel), ctx.contact);
      summary.hidden = false;

      // «Что будет дальше»: объясняем, почему ответ не мгновенный
      var next = document.createElement('div');
      next.className = 'quote-request__next';
      next.setAttribute('data-quote-next', '');
      var nt = document.createElement('p');
      nt.className = 'quote-request__next-title';
      var nx = document.createElement('p');
      nx.className = 'quote-request__next-text';
      if (isEmail) {
        // Email: срок и детали придут в самом письме, здесь только просьба найти его.
        // Структура по ТЗ: заголовок, абзац «проверьте», группа «добавьте адрес в контакты»
        // с адресом отдельной строкой (перенос до и после адреса структурный).
        nt.textContent = t(this.locale, 'emailTitle');
        var pCheck = document.createElement('span');
        pCheck.className = 'quote-request__next-line';
        pCheck.textContent = t(this.locale, 'emailCheck');
        nx.appendChild(pCheck);
        var grp = document.createElement('span');
        grp.className = 'quote-request__next-group';
        var before = document.createElement('span');
        before.className = 'quote-request__next-line';
        before.textContent = t(this.locale, 'emailAddBefore');
        var addr = ctx.sender || t(this.locale, 'ourAddress');
        // Адрес не ссылка (решение Кости): обычный текст чёрным, без подчёркивания
        var mail = document.createElement('span');
        mail.className = 'quote-request__next-mail';
        // Если адрес не помещается, переносим после «@», а не посреди слова
        var at = addr.indexOf('@');
        if (at > 0) {
          mail.appendChild(document.createTextNode(addr.slice(0, at + 1)));
          mail.appendChild(document.createElement('wbr'));
          mail.appendChild(document.createTextNode(addr.slice(at + 1)));
        } else {
          mail.textContent = addr;
        }
        var after = document.createElement('span');
        after.className = 'quote-request__next-line';
        after.textContent = t(this.locale, 'emailAddAfter');
        grp.appendChild(before);
        grp.appendChild(mail);
        grp.appendChild(after);
        nx.appendChild(grp);
      } else {
        nt.textContent = t(this.locale, 'nextTitle');
        nx.textContent = t(this.locale, 'nextText');
      }
      next.appendChild(nt);
      next.appendChild(nx);
      // блок стоит перед кнопкой «Close»
      var closeBtn = success.querySelector('.quote-request__success-close');
      success.insertBefore(next, closeBtn);
      if (body) { body.textContent = ''; body.hidden = true; }
    } else if (body && !body.textContent.trim()) {
      body.textContent = text;
    }

    if (this.form) this.form.hidden = true;
    var subtitle = scope.querySelector('.quote-request__subtitle');
    if (subtitle) subtitle.hidden = true;
    var product = scope.querySelector('.quote-request__product');
    if (product) product.hidden = true;
    var dialogTitle = scope.querySelector('.quote-request__title');
    if (dialogTitle) dialogTitle.hidden = true;

    success.hidden = false;
  };

  QuoteRequest.prototype.showMessage = function (text, kind, allowHtml) {
    if (!this.message) return;
    if (allowHtml) {
      // Сервер присылает ссылку на страницу контактов. Собираем узлы вручную
      // вместо innerHTML: в сообщение попадает только текст и один <a>,
      // никакой сторонней разметки в DOM не окажется.
      this.message.textContent = '';
      var parts = String(text).split(/<a href="([^"]*)"[^>]*>(.*?)<\/a>/);
      for (var i = 0; i < parts.length; i++) {
        if (i % 3 === 0) {
          this.message.appendChild(document.createTextNode(parts[i]));
        } else if (i % 3 === 1) {
          var a = document.createElement('a');
          a.href = parts[i];
          a.target = '_blank';
          a.rel = 'noopener';
          a.textContent = parts[i + 1];
          this.message.appendChild(a);
        }
      }
    } else {
      this.message.textContent = text;
    }
    this.message.className = 'quote-request__message quote-request__message--' + kind;
    this.message.hidden = false;
  };

  QuoteRequest.prototype.submit = function () {
    var self = this;
    var data = new FormData(this.form);

    var firstName = (data.get('firstName') || '').trim();
    var channel = this.channel();
    var email = (data.get('email') || '').trim();
    var phone = '';

    if (!firstName) return this.showMessage(t(this.locale, 'required'), 'error');

    if (!channel) {
      this.markChannelInvalid(true);
      return this.showMessage(t(this.locale, 'channel'), 'error');
    }

    var username = '';
    if (channel === 'telegram' && this.tgMode === 'username') {
      // Ник: принимаем «@name», «name» и ссылку t.me/name
      username = (this.usernameInput.value || '').trim().replace(/^https?:\/\/t\.me\//i, '').replace(/^@/, '');
      if (!/^[A-Za-z][A-Za-z0-9_]{4,31}$/.test(username)) {
        return this.showMessage(t(this.locale, 'username'), 'error');
      }
      email = '';
    } else if (channel === 'whatsapp' || channel === 'telegram') {
      phone = this.readPhone();
      if (!phone) return this.showMessage(t(this.locale, 'phone'), 'error');
      this.phoneShown = this.displayPhone(phone);
      email = '';
    } else {
      if (!email || !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) {
        return this.showMessage(t(this.locale, 'email'), 'error');
      }
      // Опечатка в домене: один раз переспрашиваем, второе нажатие принимает как есть
      var fix = suggestEmail(email);
      if (fix && this.typoOk !== email) {
        this.typoOk = email;
        return this.showMessage(t(this.locale, 'typo').replace('{fix}', fix), 'error');
      }
    }
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = t(this.locale, 'sending');
    if (this.message) this.message.hidden = true;

    var payload = {
      firstName: firstName,
      contactChannel: channel,
      email: email,
      phone: phone,
      telegramUsername: username,
      comment: (data.get('comment') || '').trim(),
      consent: true,
      variantId: this.root.dataset.variantId,
      shopDomain: this.root.dataset.shopDomain,
      locale: this.locale,
      country: this.root.dataset.country || '',
      pageUrl: window.location.href,
      gaClientId: this.getGaClientId(),
    };

    fetch(this.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.ok) {
          self.form.reset();
          self.applyChannel();
          self.trackGA(payload);
          // Показываем отдельный экран благодарности вместо формы:
          // так виден понятный результат, а не форма без полей.
          var itemTitle = self.root.querySelector('[data-quote-product-title]') || (self.modal && self.modal.querySelector('[data-quote-product-title]'));
          var itemVariant = (self.modal || self.root).querySelector('[data-quote-variant-title]');
          var itemText = [itemTitle && itemTitle.textContent.trim(), itemVariant && itemVariant.textContent.trim()].filter(Boolean).join('\n');
          self.showSuccess(json.message, {
            item: itemText,
            needed: payload.comment,
            channel: payload.contactChannel,
            contact: payload.contactChannel === 'email' ? payload.email
              : (payload.telegramUsername ? '@' + payload.telegramUsername : (self.phoneShown || payload.phone)),
            sender: json.sender
          });
        } else {
          self.showMessage(json.message, json.inStock ? 'ok' : 'error', json.html === true);
          self.submitBtn.disabled = false;
          self.submitBtn.textContent = self.submitLabel;
        }
      })
      .catch(function () {
        self.showMessage(t(self.locale, 'network'), 'error');
        self.submitBtn.disabled = false;
        self.submitBtn.textContent = self.submitLabel;
      });
  };

  // client_id из куки GA — связывает заявку с источником трафика
  QuoteRequest.prototype.getGaClientId = function () {
    var match = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
    return match ? match[1] : '';
  };

  // Событие на фронте: серверное уходит отдельно, здесь работает атрибуция
  QuoteRequest.prototype.trackGA = function (payload) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', {
        item_id: payload.variantId,
        item_name: this.root.dataset.productTitle,
        lead_locale: payload.locale,
      });
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'generate_lead',
        item_id: payload.variantId,
        item_name: this.root.dataset.productTitle,
      });
    }
  };

  function init() {
    document.querySelectorAll('[data-quote-request]').forEach(function (el) {
      if (!el.dataset.quoteReady) {
        el.dataset.quoteReady = '1';
        new QuoteRequest(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Конструктор темы пересобирает секции — переинициализируем
  document.addEventListener('shopify:section:load', init);
})();
